import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "infoPickupBox" }
const _hoisted_2 = {
  key: 2,
  class: "infoPickupBox__notActivePickupBox"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_ActiveBox = _resolveComponent("ActiveBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.activePickupBox)
      ? (_openBlock(), _createBlock(_component_Dropdown, {
          key: 1,
          class: "infoPickupBox-dropdown",
          "selected-option": _ctx.selectedPickupBox,
          options: _ctx.pickupBoxOptions,
          "data-testid": "dropdownPickupBox",
          onSelectOption: _ctx.changePickupBox
        }, null, 8, ["selected-option", "options", "onSelectOption"]))
      : _createCommentVNode("", true),
    (!_ctx.activePickupBox)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('noPickupBox')), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ActiveBox, { "active-pickup-box": _ctx.activePickupBox }, null, 8, ["active-pickup-box"])
  ]))
}